
/* 
 * Use case:
 * - Generating hash for address and organization names
 * - Generating hash for inquiry request to handle multiple requests
 *  in a short period of time
 */
const calculateCRC32 = (string) => {
    let crc = 0xFFFFFFFF; // Initial CRC value
    const polynomial = 0xEDB88320; // Standard CRC32 polynomial

    for (let i = 0; i < string.length; i++) {
        crc ^= string.charCodeAt(i); // XOR with current byte
        for (let j = 0; j < 8; j++) {
            if ((crc & 1) === 1) {
                crc = (crc >>> 1) ^ polynomial; // Shift and XOR with polynomial if LSB is 1
            } else {
                crc >>>= 1; // Shift right
            }
        }
    }

    return ((crc ^ 0xFFFFFFFF) >>> 0).toString(16).padStart(8, "0"); // Final XOR, ensure unsigned int
}

/**
 * Calculates the CRC-16/CCITT-FALSE checksum for a string.
 * This is the exact algorithm required for QR Ph and EMVCo.
 * * @param {string} data - The QR string (everything before the CRC tag value)
 * @returns {string} - A 4-character uppercase Hex string (e.g., "A1B2")
 * 
 * "The checksum shall be calculated according to [ISO/IEC 13239] using 
 * the polynomial '1021' (hex) and initial value 'FFFF' (hex). "
 * Based from: EMV® QR Code Specification for Payment Systems Merchant-Presented Mode Requirements
 */
const calculateCRC16 = (data) => {
    let crc = 0xFFFF; // Initial value for CCITT-FALSE
    const polynomial = 0x1021; // Standard polynomial

    for (let i = 0; i < data.length; i++) {
        // Get the ASCII code of the character
        let byte = data.charCodeAt(i);

        // XOR the high byte of the CRC with the current data byte
        crc ^= (byte << 8);

        for (let j = 0; j < 8; j++) {
            if ((crc & 0x8000) !== 0) {
                // If the leftmost bit is 1, shift and XOR with polynomial
                crc = ((crc << 1) ^ polynomial) & 0xFFFF;
            } else {
                // If the leftmost bit is 0, just shift
                crc = (crc << 1) & 0xFFFF;
            }
        }
    }

    // Convert to Hex and pad with leading zeros to ensure it's always 4 chars
    return crc.toString(16).toUpperCase().padStart(4, '0');
}

export default {
    calculateCRC32,
    calculateCRC16,
}
